import * as e from "react";
import s from "../lib/IconBase.es.js";
import a from "../defs/DotsThree.es.js";
const o = e.forwardRef((r, t) => /* @__PURE__ */ e.createElement(s, { ref: t, ...r, weights: a }));
o.displayName = "DotsThreeIcon";
const n = o;
export {
  n as DotsThree,
  o as DotsThreeIcon
};
